// @flow
export const formatState = (stateString: string) => String(stateString)
  .toUpperCase()
  .replace(/[^a-zA-Z]/g, '');

export default formatState;
